// Modules
import React, { useState } from "react";
import { htmlToText } from "html-to-text";
import { sanitize } from "isomorphic-dompurify";

// Types
import { ResultQuery } from "interfaces/osaSearch";

interface ProductProps {
	product: ResultQuery;
}

const InactiveProduct = ({ product }: ProductProps) => {
	const [showMoreAbstract, setShowMoreAbstract] = useState(false);

	return (
		<div className="riga R1 inactive-card">
			<div className="last colonna L1 I1">
				<div id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_CustomCSS" className="prodotto">
					<div id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_DivImmagini" className="immagine">
						<a id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_lImg" href={product.urlProduct}>
							<img
								id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_FirstProductImage"
								style={{ borderWidth: "0px" }}
								alt={htmlToText(product.title)}
								src={product.imageUrl}
							/>
						</a>
						<span className="MoreProductsNum" />
					</div>

					<div id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_pInfo" className="info medium">
						<div className="novitamini" />
						<div className="titolo">
							<a id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_lTitolo" className="linktitolo" href={product.urlProduct} title={product.title}>
								{htmlToText(product.title)}
							</a>
						</div>

						<div
							id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl00_PR_pAbstract"
							className={`abstract ${!showMoreAbstract ? "read-more-less" : ""}`}
							data-readmore="true"
							aria-expanded="false"
						>
							<div style={{ textDecoration: 'none' }} dangerouslySetInnerHTML={{ __html: sanitize(product.duration) }} />
						</div>

						{htmlToText(product.duration).length > 230 && (
							<div
								className={showMoreAbstract ? "btn_close" : "btn_expand"}
								data-readmore-toggle="ctl00_MainContent_ListaProdottiFormazione_REP_ctl03_PR_pAbstract"
								aria-controls="ctl00_MainContent_ListaProdottiFormazione_REP_ctl03_PR_pAbstract"
							>
								<span onClick={() => setShowMoreAbstract(!showMoreAbstract)}>
									<i className={`fa ${showMoreAbstract ? "fa-chevron-up" : "fa-chevron-down"}`} /> Mostra di {showMoreAbstract ? "meno" : "più"}
								</span>
							</div>
						)}
						<div id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl08_PR_pVaiScheda" className="scheda">
							<a id="ctl00_MainContent_ListaProdottiFormazione_REP_ctl08_PR_hVaiScheda" href={product.urlProduct}>
								Dettagli
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InactiveProduct;
